import { useState } from 'react';
import { simplifyToolsData } from '../qtc.utils';

export const useMeasurementTools = () => {
  const [tools, setTools] = useState(undefined);

  const setupTools = (toolsData) => {
    if (!toolsData) {
      setTools(undefined);
      return;
    }

    setTools({
      status: {
        ruler: true,
        protractor: true,
        image: true
      },
      initialCoords: {
        ruler: {
          x: 200,
          y: 200
        },
        protractor: {
          x: 200,
          y: 200
        },
        image: {
          x: 200,
          y: 200
        }
      },
      setup: simplifyToolsData(toolsData)
    });
  };

  return { tools, setupTools };
};
